import { FC } from 'react';

interface SettingRowProps {
  label: string;
  // Smaller line under the label, e.g. the email address a channel sends to.
  subtext?: string;
  value?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const SettingRow: FC<SettingRowProps> = ({
  label,
  subtext,
  value,
  onClick,
  disabled,
  children,
}) => {
  const content = (
    <>
      <span className="settings-row__text">
        <span className="settings-row__label">{label}</span>
        {subtext && <span className="settings-row__subtext">{subtext}</span>}
      </span>
      <span className="settings-row__value">
        {value}
        {children}
        {onClick && (
          <img
            src="assets/icon/settings/chevron-right.svg"
            alt=""
            className="settings-row__chevron"
          />
        )}
      </span>
    </>
  );
  return onClick ? (
    <button className="settings-row settings-row--link" onClick={onClick} disabled={disabled}>
      {content}
    </button>
  ) : (
    <div className="settings-row">{content}</div>
  );
};

interface SettingsToggleProps {
  checked: boolean;
  label: string;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const SettingsToggle: FC<SettingsToggleProps> = ({ checked, label, disabled, onChange }) => (
  <button
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    className={`settings-toggle${checked ? ' settings-toggle--on' : ''}`}
    onClick={() => onChange(!checked)}
  />
);

// Shows the last 10 digits as (949) 532 6523; anything shorter is shown as stored.
export const formatPhone = (phone?: string) => {
  const digits = (phone ?? '').replace(/\D/g, '').slice(-10);
  return digits.length === 10
    ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6)}`
    : phone ?? '';
};
